import Alert from 'emerald-ui/lib/Alert';
import Button from 'emerald-ui/lib/Button';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Alert, componentName: 'Alert' }], 'Alert'),
  description: 'The Alert shows an important message. It can be dismissed and have additional actions inside.',
  codeSamples: [
    {
      title: 'Complex content',
      scope: { Alert, Button },
      whiteBackground: true,
      code: `<Alert>
  <p style={{ padding: '10px 0', margin: 0 }}>
    This is an info message
  </p>
  <div className="btn-toolbar">
    <Button color="info">Some action</Button>
  </div>
</Alert>`,
    },
  ],
};
